import { Component, OnInit } from '@angular/core';
import { PROGRESSBAR } from '@domain/constants/app-variables';

@Component({
	selector: 'app-default-progress-bar',
	templateUrl: './default-progress-bar.component.html',
	styleUrls: ['./default-progress-bar.component.scss'],
})
export class DefaultProgressBarComponent implements OnInit {
	PROGRESSBAR = PROGRESSBAR;

	constructor() {}

	ngOnInit() {}
}
